import { forwardRef } from 'react';
import classNames from 'classnames';

import { RadioButtonSize } from '../v1/radio-button.types';

import * as S from './radio-button-v2.styles';
import { RadioButtonV2Props } from './radio-button-v2.types';

export const RadioButtonV2 = forwardRef<HTMLInputElement, RadioButtonV2Props>(
  (props, ref) => {
    const {
      ariaLabel,
      size = RadioButtonSize.Medium,
      rules,
      error,
      className,
      ...nativeProps
    } = props;

    return (
      <S.RadioButtonV2
        {...nativeProps}
        ref={ref}
        type="radio"
        aria-label={ariaLabel}
        required={!!rules?.required}
        className={classNames(
          className,
          {
            'is-invalid': error,
          },
          `size-${size}`
        )}
      />
    );
  }
);

RadioButtonV2.displayName = 'RadioButtonV2';

export default RadioButtonV2;
